import { render, staticRenderFns } from "./distributorPrice.vue?vue&type=template&id=06c24b42&"
import script from "./distributorPrice.vue?vue&type=script&lang=js&"
export * from "./distributorPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports